import React from "react"
import { withStyles, WithStyles, createStyles, Theme } from "@material-ui/core"

import BaseLinks from "../../../../../Links"
import { NavLink } from "../../../../../../content/pages/global"
import Item from "./Item"

const styles = ({ breakpoints: { up } }: Theme) => {
  return createStyles({
    root: {
      paddingLeft: "1.5625rem",
      [up("md")]: {
        paddingLeft: 0,
      },
    },
  })
}

interface Props extends WithStyles<typeof styles> {
  links: NavLink[]
}

const Links = (props: Props) => {
  return <BaseLinks {...props} Item={Item} />
}

export default withStyles(styles)(Links)
